import React, { useState } from "react";
import { Link } from "../router";
import { api } from "../api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const data = await api.post("/api/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page page-narrow">
      <div className="auth-card">
        <h1>Forgot password</h1>
        {result ? (
          <>
            <div className="alert alert-success">{result.message}</div>
            {result.testMode && (
              <div className="alert alert-warning">
                Email sending isn't configured yet, so here's the reset link directly (this only
                shows up because no email provider is set - see the README for how to configure
                one):
                <br />
                <a href={result.resetUrl}>{result.resetUrl}</a>
              </div>
            )}
          </>
        ) : (
          <form onSubmit={submit}>
            {error && <div className="alert alert-error">{error}</div>}
            <p className="muted" style={{ marginTop: 0 }}>
              Enter your account email and we'll send a link to reset your password.
            </p>
            <label>
              Email
              <input
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <button className="btn btn-primary btn-block" disabled={busy}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <p className="muted" style={{ marginTop: 16 }}>
          <Link to="/login">Back to log in</Link>
        </p>
      </div>
    </div>
  );
}
